module.exports = "<h1>Payment methods</h1>\n<ngx-paypal class=\"tertiary rounded jcenter\" [config]=\"payPalConfig\"> </ngx-paypal>"